'use client'

import { FC } from 'react';
import styled from 'styled-components';
import { font, query, space } from '@design/templateFns';

interface SearchHeroHeaderProps {
  pageTitle: string;
}

const SearchHeroHeader: FC<SearchHeroHeaderProps> = ({ pageTitle }) => {
  return (
    <Header data-testid="elastic-search-hero-header">{pageTitle}</Header>
  )
}

const Header = styled.h1`
  padding-top: ${space('x10')};
  padding-bottom: unset;
  text-align: center;
  ${font('headline-md')}

  @media screen and (${query.below('desktop')}) {
    padding-top: ${space('x8')};
  }
  @media screen and (${query.below('tablet')}) {
    padding-top: ${space('x7')};
  }
  @media screen and (${query.atLeast('tablet')}) {
    ${font('headline-xl')}
  }
`;

export default SearchHeroHeader;
